import { render, staticRenderFns } from "./masterShouts.vue?vue&type=template&id=0a405378&scoped=true&"
import script from "./masterShouts.vue?vue&type=script&lang=js&"
export * from "./masterShouts.vue?vue&type=script&lang=js&"
import style0 from "./masterShouts.vue?vue&type=style&index=0&id=0a405378&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a405378",
  null
  
)

export default component.exports